export default __webpack_public_path__ + "static/media/cloud.0af74de7.gif";